import { useState, useCallback } from "react";
import { IpLocation } from "../Models/IpLocation";
import { fetchIpLocationApi } from "../Api/ipLocation";

export const useIpLocation = () => {
  const [ipLocation, setIpLocation] = useState<IpLocation | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchIpLocation = useCallback(async (ip: string) => {
    setLoading(true);
    try {
      const data = await fetchIpLocationApi(ip);

      setIpLocation({
        city: data.city,
        region: data.region,
        country: data.country,
        latitude: data.latitude,
        longitude: data.longitude,
        accuracyRadius: data.accuracy_radius ?? 50,
        utc: data.timezone.utc,
        isp: data.connection.isp,
        flagEmoji: data.flag.emoji,
      });
    } catch {
      setIpLocation(null);
    } finally {
      setLoading(false);
    }
  }, []);

  return { ipLocation, loading, fetchIpLocation };
};
